import CaseFileUpload from "./common/CaseFileUpload";
import useRecordFiles from "../hooks/useRecordFiles";
import useRemoveRecord from "../hooks/useRemoveRecord";
import { RECORD_FILE_CONFIG } from "../utils/enum";

const RecordFileUpload = ({ caseId, recordType, disabled = false }) => {
    const { files, isLoading, isUploadPending, uploadFiles, refetch } = useRecordFiles(caseId, recordType);
    const config = RECORD_FILE_CONFIG[recordType];
    const { removeFile } = useRemoveRecord({ successMessage: config?.removeSuccessMessage, onSuccess: refetch });

    return (
        <>
            <div className="final-settlement-header mt-4">
                <div>
                    <h3 className="final-settlement-title mb-1">{config?.title}</h3>
                </div>
            </div>
            <div className="border-custom border-top-0 p-3 mb-4">
                <CaseFileUpload
                    label={config?.title}
                    files={files}
                    multiple
                    onFileSelect={uploadFiles}
                    onRemove={removeFile}
                    isLoading={isLoading || isUploadPending}
                    disabled={disabled}
                />
            </div>
        </>
    );
};

export default RecordFileUpload;
